import {toRGB, darkenHexColor} from "../../utils/colorUtils";

export const resolveSeries = (o, {
    key='w', 
    mult=100,
    rewindowStep=1
}={}) => {
    let series = {};
    let timestamps = [];
    let blanks = [];
    for (let date in o) {
        timestamps.push(date);
        let used = [];
        let tw = 0;
        for (let field in o[date]) {
            // Skip custodial_cash field
            if (field !== 'custodial_cash') {
                let w = o[date][field][key];
                used.push(field);
                if (!series.hasOwnProperty(field)) {
                    series[field] = [...blanks];
                }
                series[field].push(w > 0 ? parseFloat((w * mult).toFixed(2)) : 0);
                tw += w;
            }
        }
        for (let field in series) {
            if (!used.includes(field)) {
                series[field].push(0);
            }
        }
        blanks.push(0);
    }
    
    // Apply rewindowing if rewindowStep is greater than 1
    if (rewindowStep > 1) {
        timestamps = timestamps.filter((_, index) => index % rewindowStep === 0);
        for (let field in series) {
            series[field] = series[field].filter((_, index) => index % rewindowStep === 0);
        }
    }
    
    let columnData = [];
    let nivoColumns = [];
    let fieldnames = Object.keys(series);
    for (let i = 0; i < timestamps.length; i++) {
        let row = [timestamps[i]];
        let nivoRow = {id: timestamps[i]};
        for (let j = 0; j < fieldnames.length; j++) {
            row.push(series[fieldnames[j]][i]);
            nivoRow[fieldnames[j]] = series[fieldnames[j]][i];
        }
        columnData.push(row);
        nivoColumns.push(nivoRow);
    }
    
    return [columnData, fieldnames, nivoColumns];
}

/**
 * Filters chart data based on a start and end date.
 * @param {Array} data - The array of data points.
 * @param {string} startDate - The start date in YYYY-MM-DD format.
 * @param {string} endDate - The end date in YYYY-MM-DD format.
 * @param {number} skipInterval - The number of data points to skip.
 * @returns {Array}
 */
export const maybeFilterChartData = ({data, startDate, endDate, skipInterval=1}) => {
    if ((!startDate || !endDate) && skipInterval===1) {
        return data;
    }
    const dataWithinRange = startDate && endDate ? data.filter(item => {
        const itemDate = new Date(item.id);
        return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    }) : data;
    if (skipInterval<=1){
        return dataWithinRange;
    }
    let intervalSpacedData = [];
    for (let i = 0; i < dataWithinRange.length; i+=skipInterval) {
        intervalSpacedData.push(dataWithinRange[i]);
    }
    return intervalSpacedData;
};


export const transformSeriesForAnychart = (objects, colorMapping, chartType, opacity)=>{
    const fields = Array.from(new Set(objects.flatMap(Object.keys).filter(key => key !== 'id')));
    fields.sort();
    const labels = ['id', ...fields];
    const dataMatrix = objects.map(obj => {
        const row = [obj.id];
        fields.forEach(field => row.push(obj[field] || 0));  // Use '0' as default if field is missing
        return row;
    });
    const chartData = [];
    for (let i = 1; i < labels.length; i++) {
        const data = dataMatrix.map(row => ([row[0], row[i]]));
        chartData.push({
            data,
            name: labels[i],
            type: chartType,
            fill: {
                keys: [toRGB(colorMapping?.[labels[i]], 0.5), darkenHexColor(colorMapping?.[labels[i]], 40) ],
                angle: 90
            },
            stroke: toRGB(colorMapping?.[labels[i]], opacity),
        });
    }

    return chartData
}